<script src="node_modules/jquery/dist/jquery.min.js"></script>
<!-- Content Header (Page header) -->
<!--<section class="content-header bg-white p-3 mt-3 mx-1 rounded" style="background: white;" >
    <div class="d-flex justify-content-between pt-1 align-items-center">
        <h3><strong>Dashboard</strong></h3>
    </div>
</section>-->

<!--*********************************************************************************************************************************************************************************************************************************-->

<link href="https://unpkg.com/bootstrap-css-only@4.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://unpkg.com/@fortawesome/fontawesome-free@5.15.1/css/all.css" rel="stylesheet">
<!--<link href="https://unpkg.com/angular-calendar@0.28.22/css/angular-calendar.css" rel="stylesheet">-->
<link href="https://unpkg.com/flatpickr@4.6.6/dist/flatpickr.css" rel="stylesheet">

<!--<div id="fab-dismiss" 
     *ngIf="fabTogglerState==='active'" 
     (click)="onToggleFab()">
</div>
<div class="fab-container ">
    <button mat-fab class="fab-toggler" 
            (click)="onToggleFab()">
      <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">add</i> 
   </button>
    <div [@speedDialStagger]="buttons.length"> 
     <button *ngFor="let btn of buttons"
              mat-mini-fab
              class="fab-secondary  "   
              color="secondary" >
            
        <i class="material-icons " (click)='openFABModal(btn.icon)' title={{btn.title}} >{{btn.icon}}</i>
  
 
      </button>
    </div>
  </div>-->


<!--<button class="md-fab-right " style="right: 15px; bottom:80px;  outline: none; position: fixed; z-index: 1000; float: right;" mat-fab color="white"  id="openClientSearchModalButton"  data-toggle="modal" data-target="#ClientSearchModal">
    <i class="fa fa-user fa-2x pb-1"></i>
</button>

<button class="md-fab-right " style="right: 15px; bottom:20px;  outline: none; position: fixed; z-index: 1000; float: right;" mat-fab color="white" (click)='getSalesRepFreeTime()' id="openSalesRepAvailabilityModalButton"  data-toggle="modal" data-target="#SalesRepAvailabilityModal">
    <i class="fa fa-calendar-minus fa-2x pb-1"></i>
</button>-->

<section class="d-flex flex-column justify-content-between content-header w-100  mt-4 p-3 mb-3 mx-1 rounded text-white" style="background-color: rgb(17, 47, 77);"  >
    <div class=" pt-1 align-items-center">
        <h3 ><strong translate>Dashboard - {{branch}}</strong></h3>
    </div>
   
    <div class="d-flex justify-content-between pt-1 align-items-center border p-3 rounded" >
     
       <!-- <button class="btn mx-1 border border-white rounded text-white " style="background-color: rgb(29, 41, 53);" (click)='scrollToTableView()' translate>Appointment's Table View</button>

        <button class="btn  mx-1 border border-white rounded text-white " style="background-color: rgb(29, 41, 53);"  (click)=checkIn()  translate>Check In</button>
        
        <button class="btn mx-1 border border-white rounded text-white " style="background-color: rgb(29, 41, 53);"  (click)=openBlockOffDayModal(blockoffdayModal)  translate>Block Off Time</button>

        <button class="btn mx-1 border border-white rounded text-white "  style="background-color: rgb(29, 41, 53);" (click)=openDayOffModal(dayoffModal) translate>Assign Day Off</button>

        <button class="btn mx-1 border border-white rounded text-white " style="background-color: rgb(29, 41, 53);" routerLink="/create-appointment" translate>Create Appointment</button>
    
        <button class="btn mx-1 border border-white rounded text-white " style="background-color: rgb(29, 41, 53);"  (click)=openLunchModal(lunchModal) translate>Lunch Assignment</button>
       -->
    </div>
</section>


<div class="row d-flex p-2 m-2 justify-content-between border border-dark rounded">
<label class="m-1" style="font-family:'DINPro'; font-weight:bold; " translate>Current Person Count </label>
<label class="m-1" style="font-family:'DINPro'; font-weight:bold; ">{{todaypersonCount}}</label>
</div>






<!--*********************************************************************************************************************************************************************************************************************************-->
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

            <!-- Indicators -->
            <ul class="carousel-indicators">
                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                <li data-target="#assetSlide" data-slide-to="1"></li>
                <li data-target="#assetSlide" data-slide-to="2"></li>
            </ul>

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3" style="background-color: rgb(17, 47, 77);"  translate ><strong  translate>Today Appointments</strong>   <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;" *ngIf="alltodaysappointment!=['no appointment']" >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Request Type</th>
                        <th class="text-center p-2" translate>Sales Rep</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Tag</th>
                        <th class="text-center p-2" translate>Status</th>
                        <th class="text-center p-2" translate>Action</th>
                        <th></th>
                       
                       <ng-container class="" *ngFor='let list of alltodaysappointment | filter:searchText'>
                        <tr style="color: purple;" *ngIf='checkbarScan(list.barScan) && list.requestType!="Browsing" else other_content' [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                            <td class=""  (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                            <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                            <td class="text-white m-3  text-center " (click)=openAppointment(list) [ngClass]="list.salesRep!=''? 'badge':''"  [style.background-color]="list.salesRepColor"  style="cursor: pointer;"  >{{list.salesRep}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                           
                          
                          
                          
                           <td  *ngIf="list.status==''" class="bg-warning text-white text-center  " ><strong translate>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Pending'" class="bg-warning text-white  text-center  " ><strong translate>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='No Show'" class=" bg-danger text-white  text-center  " ><strong translate>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='In Progress'" class="bg-primary text-white  text-center  " ><strong translate>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Completed'" class="bg-success  text-white  text-center  "><strong translate>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Cancelled'" class="bg-danger text-white  text-center  "><strong translate>{{list.status}}</strong></td>

                            <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="inprogressAppointment(list)"></i><!--(click)="openInProgressModal(inProgressModal,list)"-->
                                <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                <!--<i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>-->
                               
                            </td>
                           
                                       <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                        </tr>



                        

                        <ng-template #other_content>




                            <tr class="text-success " *ngIf='list.requestType=="Browsing" else else_content'  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                                <td class="" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                <td class="text-center" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                <td class=" text-white m-3 text-center" (click)=openAppointment(list) [ngClass]="list.salesRep!=''? 'badge':''" [style.background-color]="list.salesRepColor"  style="cursor: pointer;"  >{{list.salesRep}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                               
                              
                              
                              
                               <td  *ngIf="list.status==''" class="bg-warning text-white  text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Pending'" class="bg-warning  text-white  text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='No Show'" class="bg-danger text-white  text-center  " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='In Progress'" class="bg-primary text-white  text-center " ><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Completed'" class="bg-success text-white  text-center "><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Cancelled'" class="bg-danger text-white  text-center "><strong>{{list.status}}</strong></td>
                                <td  *ngIf="list.status==''" class="text-center  p-3"><strong>{{list.status}}</strong></td>

    
                                <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                    <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="inprogressAppointment(list)"></i><!--(click)="openInProgressModal(inProgressModal,list)"-->
                                <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                <!--<i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>-->
                                   
                                </td>
                               
                                           <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                            </tr>





<ng-template #else_content>


                        <tr class=""  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                            <td class=" " [ngClass]="{'pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress'}" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                            <td class="text-center" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                            <td class=" text-center m-3 text-white" (click)=openAppointment(list) [ngClass]="list.salesRep!=''? 'badge':''"  [style.background-color]="list.salesRepColor"  style="cursor: pointer;"  >{{list.salesRep}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                          
                          
                           
                           <td  *ngIf="list.status==''" class="bg-warning text-white  text-center  " ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Pending'" class=" bg-warning  text-white  text-center  " ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='No Show'" class="bg-danger  text-white  text-center  " ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='In Progress'" class="  bg-primary  text-white  text-center  " ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Completed'" class="bg-success text-white  text-center  "><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Cancelled'" class="bg-danger text-white  text-center  "><strong>{{list.status}}</strong></td>

                            <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                               
                             <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="inprogressAppointment(list)"></i><!--(click)="openInProgressModal(inProgressModal,list)"-->
                                <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                <!--<i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>-->
                            
                            </td>
                           
                                       <td></td>
                        </tr>
                        </ng-template><!--End of Else Content-->

                        </ng-template><!--End of Other Content-->
                    </ng-container>
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>
    
     
      

    
<!----------Sales Rep Browsing Assignment Confirmation Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #confirmBrowsingAssignModal let-modal  >

    <div class="modal-header" style="z-index: 9999999;">
     <h5 class="modal-title" id="statuLabel"   translate>Browsing Assignment</h5>
     <button type="button" class="close"  style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="assignSalesRepBrowsingForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        </div>
  
      <div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold" translate> Sales Representative </label>
        <div class="col-sm-8 input-group">
    <input type="text" formControlName="salesRep" class="form-control bg-white border-0 font-weight-bolder" disabled/>   
    </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveSalesRepBrowsingAssignment(); translate>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>

<!--*********************************************************************************************************************************************************************************************************************************-->
<!--List of Browsing appointment to be assigned to sales rep-->
<button id="openBrowsingListModalButton" [hidden]="true" data-toggle="modal" data-target="#BrowsingListModal">Open Modal</button>
<!-- Modal -->
<html dir="{{direction}}">
<div id="BrowsingListModal" class="modal fade" role="dialog" style="z-index: 10000; overflow: scroll;">
    <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">
   
        <!-- Modal content-->
        <div class="modal-content " style="min-height: 15%; min-width: 68%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 68%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Browsing Appointment</strong>   <div class="p-1 mr-3">
                            <form role="form" method="post" [formGroup]="searchForm">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded form-control" formControlName='searchPhoneText' type="text" placeholder="Search by Phone Number"  
                   aria-label="Search" >
                 
                </form>
                 </div></h6>
                        
                <div  style="overflow:scroll;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px; overflow:scroll;">
                                
   
                    
                    <table class="col-md-12 border"  *ngIf="allbrowsingappointmentfortoday!='' else elseblock">
                        <thead class="border">
                            <th class=" p-2" translate>Full Name</th>
                            <th class="text-center p-2" translate>Request Type</th>
                            <th class="text-center p-2" translate>Sales Rep</th>
                            <th class="text-center p-2" translate>Phone</th>
                            <th class="text-center p-2" translate>Time In</th>
                            <th class="text-center p-2" translate>Time Out</th>
                            <th class="text-center p-2" translate>Tag</th>
                            <th class="text-center p-2" translate>Status</th>
                            <!--<th class="text-center p-2">Action</th>
                            <th></th>-->
                        </thead>
                        <tr  *ngFor='let list of allbrowsingappointmentfortoday | filter:searchText'>
                            
                          
                                <td class="p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                <td class="text-center p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                <td class="text-center p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                               <td class="text-center p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                               <td class="text-center p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                               <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                               
                              
                              
                              
                               <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong translate>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong translate>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong translate>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong translate>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong translate>{{list.status}}</strong></td>
                                <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong translate>{{list.status}}</strong></td>
    
                                <!--<td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                    <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                    <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                    <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                    <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                    <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                    <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                   
                                </td>
                               
                                           <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                            -->
                            </tr>
    
                           
                       
                        
                    </table>      
                   

                    <ng-template #elseblock> 
                        <td  class="p-3 border"  data-dismiss="modal" style="cursor: pointer;"  translate>"No Results"</td>  
                    </ng-template>
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>
    </html>

 <!--*********************************************************************************************************************************************************************************************************************************-->
 <!--<button (click)="openDialog()">Open a draggable dialog</button>

<ng-template>
  <div class="example-dialog-content" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    Drag the dialog around!
  </div>
</ng-template>
-->
 

<a id="ChatModal2" href="#" onclick='window.open("https://internal.chat.intelly.ca/", "_blank", "location=yes,height=570,width=600,scrollbars=yes,status=yes,menubar=no")'></a>

 <button id="openChatModalButton" [hidden]="true" data-toggle="modal" data-target="#ChatModal">Open Modal</button>
 <!-- Modal -->
 <div id="ChatModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static" cdkDrag>
     <div class="modal-dialog1" style="min-height: 10%; ">
 
         <!-- Modal content
         <div class="modal-content" >-->
            <div class="modal-header movemodal bg-white" style="width: 600px;">
                <h6 class="modal-title" >Chat</h6>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        
      </div>
             <iframe id="widget" src="https://internal.chat.intelly.ca/" height="650px" width="600" allow="camera;microphone"></iframe>
 
 
 
     
     </div>
     </div>
 
 
   
    
<!--*********************************************************************************************************************************************************************************************************************************-->
<!--List sales rep to be assigned to browsing appointemnt-->
<button id="openBrowsingAssignmentModalButton" [hidden]="true" data-toggle="modal" data-target="#BrowsingAssignmentModal">Open Modal</button>
<!-- Modal -->
<html dir="{{direction}}">
<div id="BrowsingAssignmentModal" class="modal fade" role="dialog">
    <div class="modal-dialog" style="min-height: 15%; min-width: 35%; background: white;">

        <!-- Modal content-->
        <div class="modal-content " style="min-height: 15%; min-width: 35%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 35%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 35%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Browsing Assignment</strong>   <div class="p-1 mr-3">
                
                 </div></h6>
               <div class="d-flex justify-content-between w-100">         
               <button class="w-100 bg-dark text-white rounded p-2" (click)='updateSalesRepListForBrowsing()'><i class="fa fa-lock"></i></button>
               <button class="w-100 bg-dark text-white rounded p-2" (click)='resetBrowsingAssignmentSalesRep()' translate>RESET</button>
               </div>
                   
                
               <div class="example-list  text-center" cdkDropList (cdkDropListDropped)="drop($event)" >
                <ng-container  *ngFor='let list of browsingSalesReplist;let indexOfelement=index;' >

        <ng-container  *ngIf='salesrepfreenext.includes(list.fullName) else notavailablerep' >
                <div class="example-box text-center row w-100 m-0 text-success border " type="button" style="cursor: pointer;" (click)=assignSalesRepToBrowsing(list,indexOfelement)     cdkDrag><div class="col-md-8 m-0 text-center">{{list.fullName}}</div><div  class="col-md-4 ">{{list.count}}</div>
                    
                    <!--<td  class="p-2 border " style="cursor: pointer;" (click)="openClientDetails(list)" data-dismiss="modal">{{list}}</td>-->     
                     
                </div>
            </ng-container>
                <ng-template  #notavailablerep> 
                    <div class="example-box text-center text-danger border m-0 row w-100"   cdkDrag><div class="col-md-8 m-0  text-center ">{{list.fullName}}</div><div  class="col-md-4 ">{{list.count}}</div>
                        </div>
                </ng-template>
            </ng-container>
            </div>
                  
                   

               
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>


</html>
    
<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openClientSearchModalButton" [hidden]="true" data-toggle="modal" data-target="#ClientSearchModal">Open Modal</button>
<!-- Modal -->
<html dir="{{direction}}">
<div id="ClientSearchModal" class="modal fade" role="dialog">
    <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

        <!-- Modal content-->
        <div class="modal-content " style="min-height: 15%; min-width: 68%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 68%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Client Search</strong>   <div class="p-1 mr-3">
                            <form role="form" method="post" [formGroup]="searchForm">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded form-control" formControlName='searchPhoneText' type="text" placeholder="Search by Phone Number"  
                   aria-label="Search" >
                   <button class="btn btn-dark mx-1 border border-white rounded text-white " (click)='clientSearch(searchForm.get("searchPhoneText").value)' translate>Submit</button>
                </form>
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
   
                    
                    <table class="col-md-12 border" *ngIf="clientSearchList!='no clients found' else elseblock">
                        <thead class="border">
                        <th class=" p-2 border" translate>Full Name</th>
                        <th class="text-center p-2 border" translate>Phone Number</th>
                        <th class="text-center p-2 border" translate>Email</th>
                        </thead>
                        <tr  *ngFor='let list of clientSearchList'>
                            
                            <td  class="p-2 border " style="cursor: pointer;" (click)="openClientDetails(list)" data-dismiss="modal">{{list.fullName}}</td>     
                            <td  class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.phoneNumber}}</td>   
                            <td  class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.email}}</td>   
                            
                           
                       
                        </tr>
                    </table>      
                   

                    <ng-template #elseblock> 
                        <td  class="p-3 border"  data-dismiss="modal" style="cursor: pointer;" >"No Results"</td>  
                    </ng-template>
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>


</html>
    
<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openSalesRepAvailabilityModalButton" [hidden]="true" data-toggle="modal" data-target="#SalesRepAvailabilityModal">Open Modal</button>
<!-- Modal -->
<html dir="{{direction}}">
<div id="SalesRepAvailabilityModal" class="modal fade" role="dialog">
    <div class="modal-dialog" style="min-height: 15%; min-width: 75%; background: white;">

        <!-- Modal content-->
        <div class="modal-content" style="min-height: 15%; min-width: 75%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 75%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 75%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Sales Representative Availability</strong>   <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                                                

                      
                        <tr *ngFor='let list of tablerequestTypearray |  filter:searchText'>
                            <ng-container *ngFor='let table of list | keyvalue'>
                            <td *ngIf="table.key==' ' else elseblock" class="p-3 border"   >{{table.value}}</td>      
                            
                            <ng-template #elseblock> 
                                <td  class="p-3 border"  data-dismiss="modal" style="cursor: pointer;" (click)='createAptFromFreeTime(list[" "],table.value)' >{{table.value}}</td>  
                            </ng-template>
                        </ng-container>
                        </tr>
                        
         
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>
</html>


    
<!----------In Progress Person Count Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #inProgressModal let-modal >
    <html dir="{{direction}}">
    <div class="modal-header" >
     <h5 class="modal-title mt-3"  id="statuLabel"  >Status Update</h5>
     <button type="button" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="tagForm" >
     
        


      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate>Person Count</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control"  id="personcount" type="text">
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="button" class="btn btn-primary" (click)=inprogressAppointment(); translate>Save</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>


<!----------Tag Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #tagModal let-modal >
    <html dir="{{direction}}">
    <div class="modal-header" >
     <h5 class="modal-title mt-3" id="statuLabel" translate >Tag</h5>
     <button type="button m-0" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="tagForm" >
     
        <div class="form-group row">
            <label class="col-sm-4 col-form-label font-weight-bold"  translate>ID</label>
          <div class="col-sm-8">  
            <input class="px-2 form-control bg-white border-0" disabled formControlName="pid" id="pid" type="text">
            </div>
          </div>
  
       <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate>Full Name</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control bg-white border-0" disabled formControlName="fullName" id="fullName" type="text">
        </div>
      </div>


      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate>Tag</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control" formControlName="tag" id="tag" type="text">
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveIndividualTag(); translate>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>



 <!----------OLD Block Off Day Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
 <ng-template #oldblockoffdayModal let-modal>
    <html dir="{{direction}}">
    <div class="modal-header">
     <h5 class="modal-title" id="statuLabel">Block Off Time</h5>
     <button type="button" class="close"  style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="blockoffdayForm" >
  
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label  class="col-sm-4 col-form-label font-weight-bold" translate>Request Type</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="requestType" id="requestType">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let list of requestTypeList' value={{list}}>{{list}}</option>
           </select>
        </div>
       </div>
  
  
      <div class="form-group row">
       
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}</option>
           </select>
        </div>
       </div>
  
       <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate> Description</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control" formControlName="fullName" id="fullName" type="text">
        </div>
      </div>
    
  
  
      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select Start Time </label>
        <div class="col-sm-8 input-group">
         
          <app-date-time-picker  formControlName="blockoffDaytimeIn" [class.is-invalid]="formErrors.blockoffDaytimeIn" (blur)="logValidationErrors()"   name="blockoffDaytimeIn"></app-date-time-picker> 
          
        </div>
      </div>
  
      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select End Time </label>
        <div class="col-sm-8 input-group">
         
          <app-date-time-picker  formControlName="blockoffDaytimeOut" [class.is-invalid]="formErrors.blockoffDaytimeOut" (blur)="logValidationErrors()" name="blockoffDaytimeOut"></app-date-time-picker> 
          
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
       <button type="submit" class="btn btn-primary"   [disabled]='!blockoffdayForm.valid || !blockoffdayForm.valid' (click)=saveIndividualBlockoffday();>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>
  
   <!----------Block Off Day Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
 <ng-template #blockoffdayModal let-modal>
    <html dir="{{direction}}">
    <div class="modal-header">
     <h5 class="modal-title mt-3" id="statuLabel" translate>Block Off Time</h5>
     <button type="button" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="blockoffdayForm" >
  
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label  class="col-sm-4 col-form-label font-weight-bold" translate>Request Type</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="requestType" id="requestType">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let list of requestTypeList' value={{list}}>{{list}}</option>
           </select>
        </div>
       </div>
  
  
     <!-- <div class="form-group row">
       
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold">Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}</option>
           </select>
        </div>
       </div>-->
       
       <div class="form-group row  ">
        <label for="userName" class="col-sm-12  col-form-label font-weight-bold" translate>Sales Representative</label>
        
            
            <div class="ml-5 w-25 d-flex flex-column" *ngFor='let rep of mainSalesReplist' style=" float:right; max-height: 550px;">
<div  class="w-100">
            <input type="checkbox"  class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"  (change)="selectSalesRep($event.target.checked,'blockOff',rep)">
            <label class="form-check-label px-1 pb-2 w-100">
              {{rep.fullName}}
            </label>
          </div>
         
        </div>
      </div>
  
       <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Description</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control" formControlName="fullName" id="fullName" type="text">
        </div>
      </div>
    
  
  
      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select Start Time </label>
        <div class="col-sm-8 input-group">
         
          <app-date-time-picker  formControlName="blockoffDaytimeIn" [class.is-invalid]="formErrors.blockoffDaytimeIn" (blur)="logValidationErrors()"   name="blockoffDaytimeIn"></app-date-time-picker> 
          
        </div>
      </div>
  
      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select End Time </label>
        <div class="col-sm-8 input-group">
         
          <app-date-time-picker  formControlName="blockoffDaytimeOut" [class.is-invalid]="formErrors.blockoffDaytimeOut" (blur)="logValidationErrors()" name="blockoffDaytimeOut"></app-date-time-picker> 
          
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary"   [disabled]='!blockoffdayForm.valid || !blockoffdayForm.valid' (click)=saveBlockoffday(); translate>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>
  

<!----------OLD Day Off Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #OLD dayoffModal let-modal >
    <html dir="{{direction}}">
    <div class="modal-header" >
     <h5 class="modal-title mt-3" id="statuLabel"   translate>Day Off Assignment</h5>
     <button type="button" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="dayoffForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let rep of salesReplist' value={{rep.userID}}>{{rep.fullName}}</option>
           </select>
        </div>
       </div>
  
  
      <div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold" translate> Select Date </label>
        <div class="col-sm-8 input-group">
          <input type="text" class="form-control" formControlName="dayoffDate"
          id="dayoffDate" name="dayoffDate" bsDatepicker
          [bsConfig]="datePickerConfig" [class.is-invalid]="formErrors.dayoffDate" (blur)="logValidationErrors()"><i
          class="input-group-addon  border p-2 fa fa-calendar fa-lg"></i>
          
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveIndividualDayoff(); translate>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>


    
<!----------Day Off Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #dayoffModal let-modal >
    <html dir="{{direction}}">
    <div class="modal-header" >
     <h5 class="modal-title mt-3" id="statuLabel"  translate >Day Off Assignment</h5>
     <button type="button" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="dayoffForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label for="userName" class="col-sm-12 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="ml-5 w-25  d-flex flex-column" *ngFor='let rep of mainSalesReplist' style=" float:right; max-height: 550px;">
            <div class="w-100" >
                        <input type="checkbox"  class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"  (change)="selectSalesRep($event.target.checked,'DayOff',rep)">
                        <label class="form-check-label px-1 pb-2 w-100">
                          {{rep.fullName}}
                        </label>
                      </div>
                     
                    </div>
       </div>
  
  
      <!--<div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold"> Select Date </label>
        <div class="col-sm-8 input-group">
          <input type="text" class="form-control" formControlName="dayoffDate"
          id="dayoffDate" name="dayoffDate" bsDatepicker placement="top right" autocomplete="off" 
          [bsConfig]="datePickerConfig" [class.is-invalid]="formErrors.dayoffDate" (blur)="logValidationErrors()"><i
          class="input-group-addon  border p-2 fa fa-calendar fa-lg"></i>
          
        </div>
      </div>-->
      <div class="w-100 text-center">
        <ngb-multi-date-picker class="w-100"
          [datesSelected]="datesSelected"
          (datesSelectedChange)="change($event)"
        ></ngb-multi-date-picker>
        </div>
        <hr />
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveDayoff(); translate>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>



    
<!----------Lunch Assignment Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #lunchModal let-modal >
    <html dir="{{direction}}">
    <div class="modal-header " style="text-align: start;" >
     <h5 class="modal-title mt-3" id="statuLabel"  style="text-align: start;"   translate>Lunch Assignment</h5>
     <button type="button" class="close"  style="margin: 0%!important; outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body modal-lg">
     <form [formGroup]="lunchForm" >
      <div class="form-group row">
         <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg" >
        <label for="userName" class="col-sm-12 w-100 text-center p-2 border bg-dark text-white my-1 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="ml-5 w-25 d-flex flex-column " *ngFor='let rep of mainSalesReplist' style=" float:right; ">
           
            <div  class=" w-100 ">
                        <input type="checkbox"  class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"  (change)="selectSalesRep($event.target.checked,'Lunch',rep)">
                        <label class="form-check-label px-1 pb-2 w-100">
                          {{rep.fullName}}
                        </label>
                      </div>
                    </div>
                   
       </div>
  
  
      <div class="form-group row">
        <label for="newBranch" class="col-sm-12 col-form-label mb-1 font-weight-bold text-center"   translate> Lunch Date </label>
        <div class="col-sm-12 input-group w-100"  style="align-content: center;"
        >
        <!--<ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden">
        </ngb-datepicker>
        
        <ng-template #t let-date let-focused="focused">
          <span class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
        <hr>

<pre>From: {{ fromDate | json }} </pre>
<pre>To: {{ toDate | json }} </pre>-->
<div class="w-100 text-center">
<ngb-multi-date-picker class="w-100"
  [datesSelected]="datesSelected"
  (datesSelectedChange)="change($event)"
></ngb-multi-date-picker>
</div>
<hr />

<div class="row mx-0 w-100 py-3">
    <label class="text-center pt-5 w-100 font-weight-bold"  translate>Lunch Time</label>
  
    <ngb-timepicker class="mx-4 mb-2 w-100"   formControlName="lunchTime"  meridian="meridian"></ngb-timepicker>
  </div>

<!--<pre>DateSelected: {{ datesSelected | json }} </pre>-->

<!--<app-date-time-picker  formControlName="lunchTime"  name="lunchTime"></app-date-time-picker>-->
    </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveLunch(); translate>Confirm</button>
      </div>
     </form>
    </div>
    </html>
   </ng-template>

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
                    <!-- Modal -->
                    <html dir="{{direction}}">
                    <div id="SuccessModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate >Appointment has been saved.</h4>
                                                </div>
                    
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysAppointment()'   data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    </html>
        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessStatusUpdateModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessStatusUpdateModal">Open Modal</button>
                    <!-- Modal -->
                    <html dir="{{direction}}">
                    <div id="SuccessStatusUpdateModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment status has been updated.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysAppointment()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>

</html>

                    
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Block/Day Off Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openOffSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#OffSuccessModal">Open Modal</button>
                    <!-- Modal -->
                    <html dir="{{direction}}">
                    <div id="OffSuccessModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                   
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                                                <div class="modal-body text-danger" *ngFor='let x of OffMessage'>
                                                    <p class="my-0 py-0">{{x}}</p>
                                                </div>
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';"  translate>Your changes have been saved</h4>
                                                </div>
                    
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysAppointment()'   data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
           </html>
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccesssModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccesssModal">Open Modal</button>
<!-- Modal -->
<html dir="{{direction}}">
<div id="SuccesssModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate >Your changes has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)='getTodaysAppointment()'   data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>
</html>

         
         

  
        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                    <!-- Modal -->
                    <html dir="{{direction}}">
                    <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment has been deleted.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysAppointment()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    </html>
                    
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                    <!-- Modal -->
                    <html dir="{{direction}}">
                    <div id="ErrorModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                                    <h4 class="modal-title text-danger" translate>ERROR</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-danger">
                                    <p>{{error}}</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
</div>

</html>                    


     









                        